import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/state/authStore';

export function RequireAdmin({ children }: { children: React.ReactNode }) {
  const isAdmin = useAuthStore((s) => s.isAdmin());
  const user = useAuthStore((s) => s.user);

  // Authentication is enforced upstream by RequireAuth; here we only handle
  // the role gate. Render a hard 403 redirect for non-admins.
  if (!user || !isAdmin) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
